import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Select,
    FormControl,
    InputLabel,
    MenuItem,
    DialogActions,
    CircularProgress,
    Grid,
    makeStyles
} from '@material-ui/core';
import Button from '../controls/Button';
import { useAccessTokens } from '../Authenticate';
import { apiGet } from '../api';

const useStyles = makeStyles((theme) => ({
    actionButtons: {
        padding: theme.spacing(3)
    }
}));

const ImportFormDialog = (props) => {
    const { open, closeDialog, linkForm } = props;
    const [selectedOption, setSelectedOption] = useState('');
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const { getAccessToken, authorizationScopes } = useAccessTokens();

    const classes = useStyles();

    useEffect(() => {
        const fetchOptions = async () => {
            setLoading(true);
            try {
                const token = await getAccessToken(authorizationScopes.forms);
                const result = await apiGet('/forms', token);
                setOptions(result?.data);
                setLoading(false)
            } catch {
                setOptions([]);
                setLoading(false);
            }
        }
        fetchOptions();
    }, [authorizationScopes.forms, getAccessToken])

    const addSelectedForm = () => {
        const formData = {
            id: selectedOption.id,
            name: selectedOption.name
        }
        linkForm(formData);
        closeDialog();
    }

    return (
        <Dialog open={open} TransitionProps={{ onEnter: () => setSelectedOption('') }} fullWidth>
            <DialogTitle>
                Import Form
            </DialogTitle>
            <DialogContent>
            <FormControl fullWidth>
                <InputLabel id="form-name-label">Form Name</InputLabel>
                <Select
                labelId="form-name-label"
                id="form-name"
                value={selectedOption}
                onChange={(event) => setSelectedOption(event.target.value)}

                >
                {loading
                    ? (<Grid container justifyContent='center'>
                        <Grid item>
                        <CircularProgress size={20}/>
                        </Grid>
                    </Grid>)
                    : (
                        options.map((option) => {
                            return <MenuItem key={option.id} value={option}>{option.name}</MenuItem>
                        })
                    )

                }
                </Select>
            </FormControl>
            </DialogContent>
            <DialogActions classes={{ root: classes.actionButtons }}>
                <Button onClick={closeDialog} >
                    Cancel
                </Button>
                <Button color="primary" variant='contained' onClick={addSelectedForm}>
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ImportFormDialog;
